(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AssistantPanelService', AssistantPanelService);

    function AssistantPanelService() {
        var state = {
            isOpen: false,
            isMinimized: false,
            context: null,
            messages: [],
            prompt: '',
            allowAssistantToChooseData: true,
            selectedDataScopes: ['billingMonthlyStats', 'waterMonthlyStats'],
            availableDataScopes: [
                {key: 'billingMonthlyStats', labelKey: 'global.assistant.billingMonthlyStats'},
                {key: 'billingDetails', labelKey: 'global.assistant.billingDetails'},
                {key: 'waterMonthlyStats', labelKey: 'global.assistant.waterMonthlyStats'},
                {key: 'waterDetails', labelKey: 'global.assistant.waterDetails'},
                {key: 'contractHistory', labelKey: 'global.assistant.contractHistory'},
                {key: 'meterChanges', labelKey: 'global.assistant.meterChanges'}
            ],
            selectedInstructionDomains: ['FINANCIAL', 'PAYMENT', 'WATER_CONSUMPTION', 'CONTRACT_STATUS'],
            availableInstructionDomains: [
                {
                    key: 'FINANCIAL',
                    labelKey: 'global.assistant.instructionDomainFinancial',
                    descriptionKey: 'global.assistant.instructionDomainFinancialDescription'
                },
                {
                    key: 'PAYMENT',
                    labelKey: 'global.assistant.instructionDomainPayment',
                    descriptionKey: 'global.assistant.instructionDomainPaymentDescription'
                },
                {
                    key: 'WATER_CONSUMPTION',
                    labelKey: 'global.assistant.instructionDomainWater',
                    descriptionKey: 'global.assistant.instructionDomainWaterDescription'
                },
                {
                    key: 'CONTRACT_STATUS',
                    labelKey: 'global.assistant.instructionDomainContract',
                    descriptionKey: 'global.assistant.instructionDomainContractDescription'
                }
            ],
            responseDetailLevel: 'SHORT',
            selectedModel: 'AUTO',
            creativityLevel: 'EQUILIBREE',
            selectedAssistantFlowMode: 'LEGACY',
            latestUsage: null,
            usageExpanded: false,
            errorMessage: null,
            isSending: false,
            didExecuteActions: false,
            userQuestionCount: 0,
            feedbackPromptVisible: false,
            feedbackPromptTrigger: null,
            feedbackReasonPromptVisible: false,
            feedbackComment: '',
            closeAfterFeedback: false,
            feedbackSubmitted: false,
            conversationId: null,
            previousResponseId: null,
            lastContextSignature: null,
            selectedMaxOutputTokens: null,
            debugCopySuccess: false,
            processingStatus: null,
            delayedProcessingMessage: null
        };

        return {
            state: state,
            open: open,
            close: close,
            toggleMinimized: toggleMinimized,
            resetConversation: resetConversation,
            updateContextEntity: updateContextEntity,
            invalidateConversationContext: invalidateConversationContext
        };

        function open(context) {
            if (!context || !context.contextType || angular.isUndefined(context.entityId) || context.entityId === null) {
                return;
            }
            var isSameContext = state.context
                && state.context.contextType === context.contextType
                && state.context.entityId === context.entityId;

            state.isOpen = true;
            state.isMinimized = false;
            state.context = angular.extend({}, context);
            applyContextDefaults();

            if (!isSameContext) {
                resetConversation();
                state.latestUsage = null;
            } else if (!state.conversationId) {
                state.conversationId = generateConversationId();
            }
        }

        function close() {
            resetConversation();
            state.latestUsage = null;
            state.isOpen = false;
            state.isMinimized = false;
        }

        function toggleMinimized() {
            state.isMinimized = !state.isMinimized;
        }

        function resetConversation() {
            state.messages = [];
            state.prompt = '';
            state.errorMessage = null;
            state.isSending = false;
            state.didExecuteActions = false;
            state.userQuestionCount = 0;
            state.usageExpanded = !!(state.context && state.context.defaultUsageExpanded);
            state.feedbackPromptVisible = false;
            state.feedbackPromptTrigger = null;
            state.feedbackReasonPromptVisible = false;
            state.feedbackComment = '';
            state.closeAfterFeedback = false;
            state.feedbackSubmitted = false;
            state.conversationId = generateConversationId();
            state.previousResponseId = null;
            state.lastContextSignature = null;
            state.selectedMaxOutputTokens = null;
            applyContextDefaults();
            state.debugCopySuccess = false;
            state.processingStatus = null;
            state.delayedProcessingMessage = null;
        }

        function applyContextDefaults() {
            state.allowAssistantToChooseData = resolveContextBoolean('defaultAllowAssistantToChooseData', true);
            state.selectedDataScopes = resolveContextArray('defaultSelectedDataScopes', ['billingMonthlyStats', 'waterMonthlyStats']);
            state.selectedInstructionDomains = resolveContextArray('defaultSelectedInstructionDomains',
                ['FINANCIAL', 'PAYMENT', 'WATER_CONSUMPTION', 'CONTRACT_STATUS']);
            state.responseDetailLevel = resolveContextString('defaultResponseDetailLevel', 'SHORT');
            state.selectedModel = resolveContextString('defaultSelectedModel', 'AUTO');
            state.creativityLevel = resolveContextString('defaultCreativityLevel', 'EQUILIBREE');
            state.selectedAssistantFlowMode = resolveContextString('defaultAssistantFlowMode', 'LEGACY');
        }

        function resolveContextBoolean(key, fallbackValue) {
            if (!state.context || angular.isUndefined(state.context[key])) {
                return fallbackValue;
            }
            return !!state.context[key];
        }

        function resolveContextArray(key, fallbackValue) {
            if (!state.context || !angular.isArray(state.context[key])) {
                return angular.copy(fallbackValue);
            }
            return angular.copy(state.context[key]);
        }

        function resolveContextString(key, fallbackValue) {
            if (!state.context || !state.context[key]) {
                return fallbackValue;
            }
            return state.context[key];
        }

        function invalidateConversationContext() {
            state.previousResponseId = null;
            state.lastContextSignature = null;
        }

        function generateConversationId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
                var randomValue = Math.random() * 16 | 0;
                var value = character === 'x' ? randomValue : ((randomValue & 0x3) | 0x8);
                return value.toString(16);
            });
        }

        function updateContextEntity(entity) {
            if (!state.context || !entity || state.context.entityId !== entity.id) {
                return;
            }
            state.context.entity = entity;
            state.context.subtitle = entity.referenceContrat ? ('#' + entity.referenceContrat) : state.context.subtitle;
            invalidateConversationContext();
        }
    }
})();
